import { render, staticRenderFns } from "./StipendiatSborStoriesView.vue?vue&type=template&id=32eced04&scoped=true&"
import script from "./StipendiatSborStoriesView.vue?vue&type=script&lang=js&"
export * from "./StipendiatSborStoriesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eced04",
  null
  
)

export default component.exports